import {
  IObservatoryRepository,
  ObservatoryKpiEntity,
  ObservatoryLayerEntity,
  ObservatoryCruceEntity,
  ObservatoryAlertEntity,
  ObservatoryDistritoEntity,
  ObservatoryUsoSueloEntity,
  ObservatoryProvinciaActivaEntity,
  ObservatoryRiesgoDonutEntity,
  TrendDirectionEnum,
  SeverityEnum,
  ResponseValueObject,
} from '@gishub/domain';

export class ObservatoryRepository implements IObservatoryRepository {
  async getKpis(): Promise<ResponseValueObject<ObservatoryKpiEntity[]>> {
    const data: ObservatoryKpiEntity[] = [
      { key: 'comunidades', value: '892', trend: '14 nuevas este mes', trendDir: TrendDirectionEnum.Up },
      { key: 'concesiones', value: '1,247', trend: '5 en alerta activa', trendDir: TrendDirectionEnum.Down },
      { key: 'areaAgricola', value: '186K ha', trend: '+4.2% vs año anterior', trendDir: TrendDirectionEnum.Up },
      { key: 'anp', value: '2.1M ha', trend: 'Estable · sin cambios', trendDir: TrendDirectionEnum.Neutral },
      { key: 'obras', value: '234', trend: '18 incorporadas este mes', trendDir: TrendDirectionEnum.Up },
      { key: 'poblacion', value: '1.4M', trend: '+1.3% crecimiento anual', trendDir: TrendDirectionEnum.Up },
      { key: 'riesgo', value: 'Moderado', trend: '', trendDir: TrendDirectionEnum.Warn },
    ];
    return new ResponseValueObject(true, data);
  }

  async getLayers(): Promise<ResponseValueObject<ObservatoryLayerEntity[]>> {
    const data: ObservatoryLayerEntity[] = [
      { id: 'dept', name: 'Departamento', group: 'Base', color: '#5DCAA5' },
      { id: 'provincias', name: 'Provincias', group: 'Base', color: '#9FE1CB' },
      { id: 'distritos', name: 'Distritos', group: 'Base', color: '#E1F5EE40' },
      { id: 'cuencas', name: 'Cuencas', group: 'Base', color: '#85B7EB' },
      { id: 'rios', name: 'Ríos', group: 'Base', color: '#378ADD' },
      { id: 'carreteras', name: 'Carreteras', group: 'Base', color: '#888780' },
      { id: 'agri', name: 'Área agrícola', group: 'Temáticas', color: '#639922' },
      { id: 'mineria', name: 'Concesiones mineras', group: 'Temáticas', color: '#EF9F27' },
      { id: 'anp', name: 'ANP', group: 'Temáticas', color: '#D4537E' },
      { id: 'comunidades', name: 'Comunidades nativas', group: 'Temáticas', color: '#7F77DD' },
      { id: 'predios', name: 'Predios catastrales', group: 'Temáticas', color: '#D85A30' },
      { id: 'zee', name: 'ZEE', group: 'Temáticas', color: '#1D9E75' },
      { id: 'reservorios', name: 'Reservorios', group: 'Infraestructura', color: '#378ADD' },
      { id: 'canales', name: 'Canales riego', group: 'Infraestructura', color: '#9FE1CB' },
      { id: 'plantas', name: 'Plantas proceso', group: 'Infraestructura', color: '#EF9F27' },
      { id: 'viveros', name: 'Viveros / Mercados', group: 'Infraestructura', color: '#97C459' },
      { id: 'centros', name: 'Centros poblados', group: 'Infraestructura', color: '#AFA9EC' },
    ];
    return new ResponseValueObject(true, data);
  }

  async getCruces(): Promise<ResponseValueObject<ObservatoryCruceEntity[]>> {
    const data: ObservatoryCruceEntity[] = [
      { type: 'agro', name: 'Corredor Agroindustrial y Mercados', icon: 'agro', bgColor: 'rgba(99,153,34,.2)', color: '#97C459' },
      { type: 'hidrico', name: 'Gestión Hídrica y Vulnerabilidad', icon: 'hidrico', bgColor: 'rgba(55,138,221,.2)', color: '#85B7EB' },
      { type: 'minero', name: 'Superposición Minero-Ambiental', icon: 'minero', bgColor: 'rgba(239,159,39,.2)', color: '#EF9F27' },
      { type: 'conflicto', name: 'Conflictos Territoriales', icon: 'conflicto', bgColor: 'rgba(226,75,74,.2)', color: '#E24B4A' },
    ];
    return new ResponseValueObject(true, data);
  }

  async getAlerts(): Promise<ResponseValueObject<ObservatoryAlertEntity[]>> {
    const data: ObservatoryAlertEntity[] = [
      { name: 'Deforestación detectada', meta: 'Satipo · Río Tambo', severity: SeverityEnum.Critical },
      { name: 'Déficit hídrico', meta: 'Cuenca Mantaro medio', severity: SeverityEnum.High },
      { name: 'Expansión agrícola', meta: 'Distrito de Pangoa', severity: SeverityEnum.Moderate },
    ];
    return new ResponseValueObject(true, data);
  }

  async getTopDistritos(): Promise<ResponseValueObject<ObservatoryDistritoEntity[]>> {
    const data: ObservatoryDistritoEntity[] = [
      { rank: 1, name: 'Satipo', severity: SeverityEnum.High },
      { rank: 2, name: 'Chanchamayo', severity: SeverityEnum.Medium },
      { rank: 3, name: 'Pangoa', severity: SeverityEnum.Medium },
      { rank: 4, name: 'Jauja', severity: SeverityEnum.Medium },
      { rank: 5, name: 'Concepción', severity: SeverityEnum.Low },
    ];
    return new ResponseValueObject(true, data);
  }

  async getUsoSuelo(): Promise<ResponseValueObject<ObservatoryUsoSueloEntity[]>> {
    const data: ObservatoryUsoSueloEntity[] = [
      { label: 'Agrícola', pct: 58, color: '#639922' },
      { label: 'ANP', pct: 22, color: '#D4537E' },
      { label: 'Minería', pct: 12, color: '#EF9F27' },
      { label: 'Urbano', pct: 8, color: '#888780' },
    ];
    return new ResponseValueObject(true, data);
  }

  async getProvinciasActivas(): Promise<ResponseValueObject<ObservatoryProvinciaActivaEntity[]>> {
    const data: ObservatoryProvinciaActivaEntity[] = [
      { name: 'Huancayo', pct: 35 },
      { name: 'Satipo', pct: 28 },
      { name: 'Chanchamayo', pct: 20 },
      { name: 'Jauja', pct: 17 },
    ];
    return new ResponseValueObject(true, data);
  }

  async getRiesgoDonut(): Promise<ResponseValueObject<ObservatoryRiesgoDonutEntity[]>> {
    const data: ObservatoryRiesgoDonutEntity[] = [
      { label: 'Alto riesgo', pct: 32, color: '#E24B4A' },
      { label: 'Moderado', pct: 20, color: '#EF9F27' },
      { label: 'Sin conflicto', pct: 48, color: '#1D9E75' },
    ];
    return new ResponseValueObject(true, data);
  }

  async getRiesgoItems(): Promise<ResponseValueObject<ObservatoryUsoSueloEntity[]>> {
    const data: ObservatoryUsoSueloEntity[] = [
      { label: 'Minero/ANP', pct: 45, color: '#E24B4A' },
      { label: 'Agrí./CC.NN', pct: 32, color: '#EF9F27' },
      { label: 'Predios/Uso', pct: 23, color: '#7F77DD' },
    ];
    return new ResponseValueObject(true, data);
  }
}
